<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="fabricCode"
      size="small"
      rsound
      auto-resize
      highlight-hover-row
      :height="570"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple ? { trigger: 'row', highlight: true, reserve: true } : {}
      "
      :checkbox-config="
        multiple ? { trigger: 'row', highlight: true, reserve: true } : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:wid="{ row }">
        <span>{{ row.wid }} </span>
        <span>{{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>{{ row.fabricWeight }} </span>
        <span>{{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ row }) {
      console.log('radioChange >>', row)
      this.$emit('choose-change', row)
    },
  },
}
</script>
